// Copyright (c) 2024-2026 Noushad Khalid / Codeteki. All rights reserved.
// Licensed under the Elastic License 2.0 — see LICENSE for details.

import { useEffect, useRef } from 'react';
import { useLocation } from 'wouter';
import { trackPageView } from '../lib/analytics';
import { trackPixel } from '../lib/pixel';

export const useAnalytics = () => {
  const [location] = useLocation();
  const prevLocationRef = useRef(location);
  
  useEffect(() => {
    if (location !== prevLocationRef.current) {
      trackPageView(location);
      trackPixel('PageView'); // initial PageView comes from the base snippet in index.html
      prevLocationRef.current = location;
    }
  }, [location]);
};